document.addEventListener('DOMContentLoaded', () => {
    window.dataLayer = window.dataLayer || [];

    document.querySelectorAll('.checkbox-custom').forEach((checkbox) => {
        checkbox.addEventListener('click', function () {
            dataLayer.push({
                'event': 'checkbox_click',
                'checkbox_value': this.getAttribute('data-checkbox'),
                'checkbox_checked': this.checked // true ili false
            });
        });
    });


    var burger = document.querySelector('#burger');

    if (burger) {
        var nav = document.querySelector('.navbar');
        var body = document.body;
        burger.addEventListener('click', () => {
            burger.classList.toggle('open');
            nav.classList.toggle('opened');
            body.classList.toggle('no-scroll');
        });

        var navLinks = document.querySelectorAll('.navbar a');

        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                burger.classList.remove('open');
                nav.classList.remove('opened');
                body.classList.remove('no-scroll');
            });
        });
    }

   
    const calendlyUrl = "https://calendly.com/mpu-institut-berlin/telefontermin";

    function createCalendlyIframe() {
        const iframe = document.createElement('iframe');
        iframe.src = calendlyUrl;
        iframe.width = "100%";
        iframe.height = "500";
        return iframe;
    }

    function addIframeToForminatorSuccess() {
        const specificSuccessDiv = document.querySelector('#hero .forminator-success'); 
        if (specificSuccessDiv && !specificSuccessDiv.dataset.iframeAdded) {
             specificSuccessDiv.textContent = '';
            const iframe = createCalendlyIframe();
            specificSuccessDiv.appendChild(iframe);
            specificSuccessDiv.dataset.iframeAdded = true; 
        }
    }

    function addIframeToForminatorSuccess2() {
        const specificSuccessDiv = document.querySelector('#financial .forminator-success'); 
        if (specificSuccessDiv && !specificSuccessDiv.dataset.iframeAdded) {
             specificSuccessDiv.textContent = '';
            const iframe = createCalendlyIframe();
            specificSuccessDiv.appendChild(iframe);
            specificSuccessDiv.dataset.iframeAdded = true; 
        }
    }

    const observer = new MutationObserver(function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                addIframeToForminatorSuccess();
                addIframeToForminatorSuccess2();
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    addIframeToForminatorSuccess();
    addIframeToForminatorSuccess2();


    

    // Form style customization 

    const forms = document.querySelectorAll('.forminator-custom-form');

    if (forms.length > 0) {
        forms.forEach(form => {
            const paginationSteps = form.querySelectorAll('.forminator-pagination');
            if (paginationSteps.length > 0) {
                const lastStep = paginationSteps[paginationSteps.length - 1];
                lastStep.classList.add('last-step');
            }
        });
    }

    var formBg = document.querySelectorAll('.formTop');
    changeBg();


    window.addEventListener('resize', () => {
        changeBg();
    });

    function changeBg() {
        if (formBg.length > 0) {
            if (window.innerWidth > 800 && window.innerWidth < 1400) {
                formBg.forEach(bg => {
                    bg.setAttribute('src', '/wp-content/themes/inity/assets/img/form_bg_md.svg')
                })
            }
        }
    }
    var pricingBg = document.querySelectorAll('.pricing_bg');
    changePricingBg();

    window.addEventListener('resize', () => {
        changePricingBg();
    });

    function changePricingBg() {
        if (pricingBg.length > 0) {
            if (window.innerWidth > 800 && window.innerWidth < 1440) {
                pricingBg.forEach((bg, index) => {
                    bg.setAttribute('src', '/wp-content/themes/inity/assets/img/pricing_bg_md.svg');
                    if (index === 1) {
                        bg.setAttribute('src', '/wp-content/themes/inity/assets/img/pricing_bg_md.svg');
                    }
                });
            }
        }
    }




    // Testimonials scroll functionality
    const testimonials = gsap.utils.toArray('.testimonial');

    if (testimonials.length > 0) {
        const showTestimonial = () => {
            document.body.style.overflow = 'auto';
            document.scrollingElement.scrollTo(0, 0);

            gsap.utils.toArray('.section').forEach((section, index) => {
                const w = section.querySelector('.wrapper');
                const [x, xEnd] = (index % 2) ? ['10%', (w.scrollWidth - section.offsetWidth) * -0.2] : [w.scrollWidth * -0.2, 0];
                gsap.fromTo(w, { x }, {
                    x: xEnd,
                    scrollTrigger: {
                        trigger: section,
                        scrub: 0.5
                    }
                });
            });
        }

        showTestimonial();
    }

    const benefits = document.querySelectorAll('.accordion-item');
    const images = document.querySelectorAll('.accordion-item-image');

    if (benefits.length > 0) {
        benefits.forEach((benefit, index) => {
            benefit.addEventListener('mouseenter', () => {
                // Remove 'active' class and hide content from all other benefits
                benefits.forEach((otherBenefit, otherIndex) => {
                    if (otherBenefit !== benefit) {
                        otherBenefit.classList.remove('active');
                        otherBenefit.querySelector('.accordion-content').style.maxHeight = '0px';

                        // Hide all images
                        if (images[otherIndex]) {
                            images[otherIndex].classList.remove('active-image');
                        }
                    }
                });

                // Toggle 'active' class for the hovered benefit
                benefit.classList.toggle('active');
                const content = benefit.querySelector('.accordion-content');
                if (content.style.maxHeight && content.style.maxHeight !== '0px') {
                    content.style.maxHeight = '0px';
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }

                // Show the corresponding image
                if (images[index]) {
                    images[index].classList.add('active-image');
                }
            });
        });
    }


    // FAQ section functionality
    const faqItems = document.querySelectorAll('.faqs-item');
    if (faqItems.length > 0) {
        faqItems.forEach(item => {
            const title = item.querySelector('.faqs-item-title');
            const content = item.querySelector('.faqs-item-content');
    
            title.addEventListener('click', () => {
                // Close all other contents
                faqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        const otherContent = otherItem.querySelector('.faqs-item-content');
                        otherContent.style.maxHeight = '0px';
                        otherItem.classList.remove('faq-active');
                    }
                });
    
                // Toggle current content and add/remove class on faqs-item
                if (content.style.maxHeight && content.style.maxHeight !== '0px') {
                    content.style.maxHeight = '0px';
                    item.classList.remove('faq-active');
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    item.classList.add('faq-active');
                }
            });
        });
    }

    var loadMoreBtn = document.getElementById('load-more-button');
    if(loadMoreBtn){
        loadMoreBtn.addEventListener('click', (e) => {
            e.preventDefault();
            var faqs = document.querySelector('.faqs');

            faqs.style.maxHeight = '500rem';
            faqs.style.overflow = 'visible';
            
            var loadMore = document.querySelector('.load-more');
            loadMore.style.display = 'none';
            loadMore.style.opacity = '0';
        });
    }

    // Testimonials section functionality - Swiper
    var testimonialsSlider = document.querySelectorAll('.testimonials-slider');

    if (testimonialsSlider.length > 0) {
        const swiper = new Swiper('.testimonials-slider', {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            // autoplay: {
            //     delay: 2500,
            //     disableOnInteraction: true,
            // },
            autoplay: false,
            grabCursor: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2.5,
                }
            }

        });
    };

    // var scrollSteps = document.querySelectorAll('.scroll-steps');

    // scrollSteps.forEach(function (scrollStep, index) {
    //     new Swiper(scrollStep, {
    //         slidesPerView: 1,
    //         spaceBetween: 0,
    //         grabCursor: true,
    //         centeredSlides: false,
    //         mousewheel: true,
    //         loop: false,
    //         pagination: false,
    //         autoplay: false,
    //         breakpoints: {
    //             800: {
    //                 direction: "vertical",
    //                 slidesPerView: 1.33,
    //                 spaceBetween: 0,
    //                 grabCursor: true,
    //                 centeredSlides: false,
    //                 navigation: false,
    //             }
    //         }
    //     });
    // });

});